import styled from 'styled-components';
import { MOBILE_SLIDER_BREAKPOINT, SELECTORS } from '../../../constants/constants';

export const DesktopSliderContainer = styled.div`
  ${SELECTORS} & {
        width: 90%;
        margin: auto;
  }
  @media (max-width: ${MOBILE_SLIDER_BREAKPOINT}) { 
      ${SELECTORS} & {
          display: none;
      }
  }
`;

export const DesktopGameSliderImageContainer = styled.div`
   ${SELECTORS} & {
      display: block;
      padding: 10px;
      img{
        max-width: 100%;
        height: auto;
        border-radius: 18px;
      }
   }
`;

export const DesktopSliderArrowLeft = styled.div`
    ${SELECTORS} & {
      position: absolute;
      top: 50%;
      left:  -5.5%;
      margin-top: -25px;
      z-index: 10;
      cursor: pointer;
      color: transparent;
      border: none;
      outline: none;
      &:hover   {
          opacity: 0.75;
      }
  }
}
`;

export const DesktopSliderArrowRight = styled.div`
    ${SELECTORS} & {
        position: absolute;
        top: 50%;
        margin-left: -23px;
        left: 105.5%;
        margin-top: -25px;
        z-index: 10;
        cursor: pointer;
        color: transparent;
        border: none;
        outline: none;
        &:hover   {
          opacity: 0.75;
        }
    }
`;

